module.exports = __webpack_public_path__ + "whatsapp.png";